import { useState } from 'react';

import './FAQ.css';
import Navbar from '../../components/navbars/Navbar'
import { FaCircleChevronUp } from "react-icons/fa6";
import { FaCircleChevronDown } from "react-icons/fa6";


export default function FAQ() {
    // Define state for each question's visibility
    const [isOpen, setIsOpen] = useState({
        question1: false,
        question2: false,
        question3: false,
        question4: false,
        question5: false,
        question6: false,
    });

    const toggleAnswer = (question) => {
        setIsOpen((prevState) => ({
            ...prevState,
            [question]: !prevState[question],
        }));
    };

    return (
        <div className='faqPage'>
            <Navbar />
            <h1>FAQ</h1>
            <div className='faq'>
                <div className='question' onClick={() => toggleAnswer('question1')}>
                    <div>
                        {isOpen.question1 ? (
                            <FaCircleChevronDown color='dodgerblue' />
                        ) : ( 
                            <FaCircleChevronUp color='#3c3c3c' />
                        )}
                        
                    </div>
                    <h3>What is Albums and Art?</h3>
                    {isOpen.question1 && <p>Albums and Art is a photo editing and album design service. We offer free album design with every album purchase and a team to edit your photos.</p>}
                </div>
                <div className='question' onClick={() => toggleAnswer('question2')}>
                <div>
                        {isOpen.question2 ? (
                            <FaCircleChevronDown color='dodgerblue' />
                        ) : ( 
                            <FaCircleChevronUp color='#3c3c3c' />
                        )}
                        
                    </div>
                    <h3 >How do I upload my photos?</h3>
                    {isOpen.question2 && <p>You can upload your photos in the "My Orders" page and then selecting your order / item by clicking on the "Upload Photos" button on the homepage. You can also upload photos by clicking on the "Upload Photos" button on the "Shop" page.</p>}
                </div>
                <div className='question' onClick={() => toggleAnswer('question3')}>
                <div>
                        {isOpen.question3 ? (
                            <FaCircleChevronDown color='dodgerblue' />
                        ) : ( 
                            <FaCircleChevronUp color='#3c3c3c' />
                        )}
                        
                    </div>
                    <h3>How do I order?</h3>
                    {isOpen.question3 && <p>You can order by clicking on the "Order" button on the album or product page. You can also order by clicking on the "Order" button on the "Shop" page.</p>}
                </div>
                <div className='question' onClick={() => toggleAnswer('question4')}>
                <div>
                        {isOpen.question4 ? (
                            <FaCircleChevronDown color='dodgerblue' />
                        ) : ( 
                            <FaCircleChevronUp color='#3c3c3c'  />
                        )}
                        
                    </div>
                    <h3>How do I pay?</h3>
                    {isOpen.question4 && <p>We offer a variety of payment options. You can pay by credit card, PayPal, or Affirm.</p>}
                </div>
                <div className='question' onClick={() => toggleAnswer('question5')}>
                <div>
                        {isOpen.question5 ? (
                            <FaCircleChevronDown color='dodgerblue' />
                        ) : ( 
                            <FaCircleChevronUp color='#3c3c3c' />
                        )}
                        
                    </div>
                    <h3>How long does it take to get my photos?</h3>
                    {isOpen.question5 && <p>It mainly depends on how fast you get the images uploaded for your order. On average, we can get your album to you in 1-2 weeks.  Products such as Edge-Prints can be shipped in 3-4 days.</p>}
                </div>
                <div className='question' onClick={() => toggleAnswer('question6')}>
                    <div>
                        {isOpen.question6 ? (
                            <FaCircleChevronDown  color='dodgerblue' />
                        ) : (
                            <FaCircleChevronUp  color='#3c3c3c' />
                        )}

                    </div>
                    <h3 onClick={() => toggleAnswer('question6')}>What if I have a question that is not answered here?</h3>
                    {isOpen.question6 && <p>Please contact us at <a href="mailto:info@albumsandart.com">info@albumsandart.com</a></p>}
                </div>
            </div>
        </div>
    );
}
